import TyCircle from './TyCircle.vue'
export default TyCircle



// WEBPACK FOOTER //
// ./src/components/ty-circle/index.js